import { IRatingTheme } from '../../models/IRatingTheme';
import { colors } from './colors';

export const RatingTheme: IRatingTheme = {
  default: {
    color: colors.notTransactional.base,
  },
  disabled: {
    color: colors.neutral.grayLight,
  },
};
